/* =========================================================================
     REVISION REQUEST FORM AUTO-SYNC
  ========================================================================= */
(function () {
    let revisionRecordId = null;
    let revisionDebounceTimer = null;
    let isRevisionCreating = false;
    let revisionCreationPromise = null;

    // Called on modal OPEN — treat the upcoming session as a brand-new prospect.
    window.resetRevisionRecordId = function () {
        clearTimeout(revisionDebounceTimer);
        revisionRecordId = null;
    };

    // Called on modal CLOSE — stop any pending sync and flag the record (if any)
    // as closed/finalized so Airtable reflects this prospect session is done
    // rather than silently abandoned.
    window.finalizeRevisionRecord = function () {
        clearTimeout(revisionDebounceTimer);
        const recordId = revisionRecordId;
        revisionRecordId = null;
        if (!recordId) return;

        try {
            fetch('https://webhooks.codeblue.agency/api/revision/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                keepalive: true,
                body: JSON.stringify({
                    record_id: recordId,
                    status: 'complete',
                    project: 'SignMakerz'
                })
            }).then(function (response) {
                return response.json().catch(function () { return null; });
            }).then(function (result) {
                console.log('[Revision Live Sync] Finalized Airtable Record ID:', recordId, result);
            }).catch(function (err) {
                console.error('[Revision Live Sync Finalize Exception]:', err);
            });
        } catch (err) {
            console.error('[Revision Live Sync Finalize Exception]:', err);
        }
    };

    // Called after a revision request is successfully submitted — flags the
    // Airtable record with sent_to_at so the backend can branch on its presence.
    window.markRevisionSentToAt = function () {
        const recordId = revisionRecordId;
        if (!recordId) return;

        try {
            fetch('https://webhooks.codeblue.agency/api/revision/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                keepalive: true,
                body: JSON.stringify({
                    record_id: recordId,
                    sent_to_at: true,
                    project: 'SignMakerz'
                })
            }).then(function (response) {
                return response.json().catch(function () { return null; });
            }).then(function (result) {
                console.log('[Revision Live Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
            }).catch(function (err) {
                console.error('[Revision Live Sync sent_to_at Exception]:', err);
            });
        } catch (err) {
            console.error('[Revision Live Sync sent_to_at Exception]:', err);
        }
    };

    // Helper to get selected Sign Type on product page or modal
    function getSelectedSignType() {
        const modalSignType = document.querySelector('#revisionModal .rev-sign-chip.is-selected, #revisionModal .sign-type-chip.selected, #revisionModalOverlay .rev-sign-chip.is-selected, #revisionModalOverlay .sign-type-chip.selected, #revSignTypeInput');
        if (modalSignType && modalSignType.value) return modalSignType.value.trim();

        const styleRadio = document.querySelector(
            'fieldset[name="Style"] input[type="radio"]:checked, ' +
            'fieldset[name="Sign Type"] input[type="radio"]:checked, ' +
            'fieldset[name="Variation"] input[type="radio"]:checked, ' +
            'input[name="properties[Sign Type]"], ' +
            'input[name="properties[Style]"]'
        );
        if (styleRadio && styleRadio.value) return styleRadio.value.trim();

        if (typeof SMZ !== 'undefined' && SMZ.type) {
            if (typeof styleData !== 'undefined' && styleData[SMZ.type] && styleData[SMZ.type][0] && styleData[SMZ.type][0].name) {
                return styleData[SMZ.type][0].name;
            }
            if (typeof smzGetApiSignType === 'function') {
                return smzGetApiSignType(SMZ.type);
            }
            return SMZ.type;
        }
        return '';
    }

    // Helper to get selected Type of Change
    function getSelectedTypeOfChange() {
        const typeEl = document.getElementById('revTypeOfChange') ||
            document.getElementById('revChangeType') ||
            document.querySelector('select[name="type_of_change"]') ||
            document.querySelector('#revisionModal .rev-change-chip.is-selected, #revisionModalOverlay .rev-change-chip.is-selected');
        return typeEl ? (typeEl.value || typeEl.textContent || '').trim() : '';
    }

    // Visitor location saved to localStorage by theme.liquid
    function getStoredLocation() {
        try {
            return localStorage.getItem('location') || '';
        } catch (e) {
            return '';
        }
    }

    // Extract form input data
    function getRevisionFormData() {
        const typeOfChangeVal = getSelectedTypeOfChange();
        const typeOfSignVal = getSelectedSignType();
        const detailsEl = document.getElementById('revDetails') || document.getElementById('revDetailsOfChange') || document.querySelector('#revisionModal textarea, #revisionModalOverlay textarea, textarea[name="change_details"], textarea[name="details_of_change"]');
        const detailsVal = detailsEl ? detailsEl.value.trim() : '';

        return {
            type_of_change: typeOfChangeVal,
            type_of_sign: typeOfSignVal,
            change_details: detailsVal,
            location: getStoredLocation(),
            payment_url: window.location.href,
            project: 'SignMakerz' // Hardcoded Project Name for Airtable Single Select
        };
    }

    // Core Sync Function (Create or Update)
    async function syncRevisionData() {
        // Race-condition guard: Wait if initial creation request is still pending
        if (isRevisionCreating && revisionCreationPromise) {
            try {
                await revisionCreationPromise;
            } catch (e) {
                // Ignore initial error to allow retry
            }
        }

        const data = getRevisionFormData();

        // Do not submit if all relevant fields are empty
        if (!data.type_of_change && !data.type_of_sign && !data.change_details) {
            return;
        }

        const doFetch = async () => {
            const isUpdate = Boolean(revisionRecordId);
            const endpoint = isUpdate
                ? 'https://webhooks.codeblue.agency/api/revision/update'
                : 'https://webhooks.codeblue.agency/api/revision/create';

            const payload = {
                ...data,
                project: 'SignMakerz'
            };

            if (isUpdate && revisionRecordId) {
                payload.record_id = revisionRecordId;
            }

            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    if (!revisionRecordId && result.record_id) {
                        revisionRecordId = result.record_id;
                        console.log('[Revision Live Sync] Created Airtable Record ID:', revisionRecordId);
                    } else {
                        console.log('[Revision Live Sync] Updated Airtable Record ID:', revisionRecordId);
                    }
                    return result;
                } else {
                    console.error('[Revision Live Sync Error]:', result);
                }
            } catch (err) {
                console.error('[Revision Live Sync Exception]:', err);
            }
        };

        const initialRecordId = revisionRecordId;
        if (!initialRecordId && !isRevisionCreating) {
            isRevisionCreating = true;
            revisionCreationPromise = doFetch().finally(() => {
                isRevisionCreating = false;
                revisionCreationPromise = null;
            });
            return revisionCreationPromise;
        } else {
            return doFetch();
        }
    }

    window.syncRevisionData = syncRevisionData;

    // Debounced listener (Fast 500ms initial creation, 2000ms update debounce)
    function handleRevisionLiveInput() {
        clearTimeout(revisionDebounceTimer);
        const delay = revisionRecordId ? 2000 : 500;
        revisionDebounceTimer = setTimeout(() => {
            syncRevisionData();
        }, delay);
    }

    // Global Event Delegation for Revision Modal
    document.addEventListener('input', (e) => {
        if (e.target && e.target.closest('#revisionModal, #revisionModalOverlay, #revisionForm, .revision-overlay, .rev-modal-overlay')) {
            handleRevisionLiveInput();
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target && e.target.closest('#revisionModal, #revisionModalOverlay, #revisionForm, .revision-overlay, .rev-modal-overlay')) {
            handleRevisionLiveInput();
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target && e.target.closest('#revisionModal .rev-sign-chip, #revisionModal .sign-type-chip, #revisionModal .type-select-btn, .rev-sign-chip, .sign-type-chip, .type-select-btn')) {
            handleRevisionLiveInput();
        }
    });
})();